import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../global/ui/Button";
import InputField from "../../global/ui/InputField";
import { apiConstants } from "../../utils/constants/apiConstants";
import { STRING_CONSTANTS } from "../../utils/constants/stringConstants";

import { makeGetCall, makePostCall } from "../../effects/requests";
import endpoints from "../../utils/endpoints";

import useStore from "../../zustandstore";
import {
  getStylistShopifyStoreUrl,
  getURLstylistCode,
  getURLwithstylistCode,
  isNotEmptyString,
} from "../../utils/globalFunctions";
import GooglePlacesSearchBar from "../../global/ui/GooglePlacesSearchBar";
import useCurrentAddress from "../../hooks/useCurrentAddress";

import DOMPurify from "dompurify";
import { images } from "../../utils/constants/assets";
import { getLocalStorage, showToast } from "../../utils";
import { hasDatePassedStatus } from "../../utils/dateUtils";
import {
  getMobileBookingLocationId,
  MOBILE_BOOKING_FORM_VALUE,
} from "../../utils/onlineBookingLocation";

interface LocationProps {
  handleNext: () => void;
  control?: any;
  errors?: any;
  watch?: any;
  setValue?: any;
  setTotalAmountArr?: any;
  getValues?: any;
  // stylistlocationData?: any;
  // setStylistLocationData?: any;
}

type _locationDataType = {
  full_name: string;
  profile_picture: string;
  address;
  setValue: string;
};

async function getMobileBookingSchedule() {
  const apiMobileResponse = await makeGetCall({
    url: `${endpoints.mobile_booking_schedule}${getURLstylistCode()}`,
  });
  return apiMobileResponse?.data || [];
}

const isAvailableForOnlineBooking = (location: any) =>
  location?.name !== "Mobile Booking" &&
  location?.is_available_for_online_booking === true &&
  !(
    location?.online_booking_status?.includes("Ends") &&
    hasDatePassedStatus(location?.online_booking_status)
  );

export default function Location(props: LocationProps) {
  const {
    control,
    _errors,
    handleNext,
    watch,
    setValue,
    getValues,
    setTotalAmountArr,
    // stylistlocationData,
    // setStylistLocationData,
  } = props;

  const [showPopup, setShowPopup] = useState(false);

  const { locationNotFound, setLocationNotFound } = useStore(
    (state: any) => state
  );

  const mainstylistLocationData = useStore(
    (state: any) => state.stylistLocationData
  );

  const updateStylistLocationData = useStore(
    (state: any) => state.setStylistLocationData
  );

  //Initalizing location_id in zustandstore when app is loaded for the first time
  const { setLocationId, location_id, setTimezoneId, setSelectedService } = useStore(
    (state: any) => state
  );

  const setMobileWorkingHours = useStore((state: any) => state.setMobileWorkingHours);
  const setLocationWorkingHours = useStore((state: any) => state.setLocationWorkingHours);
  const { locationLatitude, setLocationLatitude } = useStore((state: any) => state);
  const { locationLongitude, setLocationLongitude } = useStore((state: any) => state);

  async function getResponse() {
    try {
      const apiResponse = await makeGetCall({
        url: `${endpoints.stylist_location}?${getURLwithstylistCode()}`,
      });

      const data = await apiResponse;
      updateStylistLocationData(data);
      if (data.status.code === 200) {
        const firstAvailable = (data?.results || []).find(
          isAvailableForOnlineBooking
        );

        if (!isNotEmptyString(location_id) && firstAvailable) {
          setLocationId(firstAvailable.id);
          setLocationWorkingHours(firstAvailable.working_hours);
        }

        if (
          !isNotEmptyString(getValues(apiConstants.location)) &&
          !isNotEmptyString(getValues(apiConstants.custom_location)) &&
          firstAvailable
        ) {
          setValue(apiConstants.location, firstAvailable.id);
          setValue(apiConstants.timezone, firstAvailable.timezone);
        }
      } else {
        showToast(data.status.message, "error");
      }
      setSelectedService([]);
    } catch (err) {
      console.log(err);
    }
  }

  async function getTimeZoneInMbl() {
    let apiPayload = {
      location: [locationLatitude, locationLongitude],
    };

    try {
      const apiResponse = await makePostCall({
        url: endpoints.timezone,
        apiPayload,
      });

      if (apiResponse.status.code === 200) {
        setTimezoneId(apiResponse?.data?.tz);
      } else {
        showToast(apiResponse.status.message, "error");
      }
    } catch (err) {}
  }

  useEffect(() => {
    //setLocationId(null);
    getResponse();
  }, []);

  useEffect(() => {
    if (locationLatitude != null) {
      getTimeZoneInMbl();
    }
  }, [locationLatitude]);

  useEffect(() => {
    async function fetchMobileBookingSchedule() {
      const hours = await getMobileBookingSchedule();
      setMobileWorkingHours(hours);
    }
    fetchMobileBookingSchedule();
  }, [setMobileWorkingHours]);

  const handleSubmit = () => {
    setTimezoneId(getValues(apiConstants.timezone));
    setTotalAmountArr([]);
    handleNext();
  };

  const {
    curraddress,
    lat,
    lng,
    city,
    country,
    country_code,
    state,
    state_code,
    zip_code,
    _error,
  } = useCurrentAddress();

  useEffect(() => {
    if (!getValues(apiConstants.custom_location) && showPopup) {
      setValue(apiConstants.custom_location, curraddress);
      setValue(apiConstants.lat, lat);
      setValue(apiConstants.lng, lng);
      setValue(apiConstants.custom_location_object, {
        address: curraddress,
        country: country,
        country_code: country_code,
        location: [lat, lng],
        city: city,
        zip_code: zip_code,
        state: state,
        state_code: state_code,
      });
    }
  }, [curraddress, showPopup]);

  const handlePopClick = () => {
    setShowPopup(!showPopup);
    // const geo = navigator.geolocation;

    // setLocationNotFound(true);
  };

  const _handleLocationError = () => {
    setLocationNotFound(false);
  };

  const radioValue = watch(apiConstants.location);

  const MobileBookingBtn = () => {
    setShowPopup(false);
  };

  const showInMapClicked = (location) => {
    window.open(
      "https://maps.google.com?q=" +
        location.location[0] +
        "," +
        location.location[1],
      "_blank"
    );
  };

  const access_token = getLocalStorage("access_token");

  const setShowNav = useStore((state: any) => state.setShowNav);
  const navOpen = () => {
    setShowNav(true);
  };

  const [_one, setOne] = useState("");
  const navigate = useNavigate();
  const re_book_past = () => {
    // const urlParams = new URLSearchParams(window.location.search);
    // let uc = urlParams.get("stylist_unique_code");
    navigate(`/${getURLstylistCode()}/bookings/?rebook`);
    // setCondition(true);
    // setbookingType("past");
    setOne("true");
  };

  const [_isMblDisabled, _setIsMblDisabled] = useState(false);
  const mobileBookingData = mainstylistLocationData?.results?.find((location: any) => location?.name === "Mobile Booking") ?? null;

  const availableLocationIds = new Set<string>(
    (mainstylistLocationData?.results || [])
      .filter(isAvailableForOnlineBooking)
      .map((loc: any) => loc.id)
  );

  const isMobileBookingAvailable =
    !!mainstylistLocationData?.stylist_info?.is_consumer_preferred_address_allowed &&
    mobileBookingData?.is_available_for_online_booking === true;

  useEffect(() => {
    if (radioValue === MOBILE_BOOKING_FORM_VALUE && mobileBookingData?.id) {
      setLocationId(mobileBookingData.id);
    }
  }, [radioValue, mobileBookingData?.id, setLocationId]);

  const hasValidSelection =
    radioValue === "mbl_booking"
      ? isMobileBookingAvailable &&
        isNotEmptyString(watch(apiConstants.custom_location))
      : availableLocationIds.has(radioValue);

  return (
    <div className="step_1">
      <div className="upper-wrapper">
        {access_token ? (
          <div className="go-back">
            <div>
              <a 
                href={getStylistShopifyStoreUrl()}
                style={{ textDecoration: 'none', color: 'black' , fontWeight: 'bold' }}
                target="_blank" rel="noreferrer"
              >
                <div>
                  {" "}
                  <img
                    src={images.shopping_cart}
                    alt="shopping-cart-icon"
                    style={{ width: "auto", height: "1rem", marginRight: "0.5rem" }}
                  />
                  {STRING_CONSTANTS.visit_store}
                </div>
              </a>
            </div>
            <div className="user-icon" onClick={navOpen}>
              <img src={images.user_1} alt="" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="prsn-img">
        <img
          src={
            mainstylistLocationData?.stylist_info?.business_logo || 
            mainstylistLocationData?.stylist_info?.profile_picture
          }
          alt=""
        />
        </div>
        <h1>
          Book an appointment with{" "}
          {
            mainstylistLocationData?.stylist_info?.business_name ||
            mainstylistLocationData?.stylist_info?.full_name
          }
        </h1>
        <p>Please select your preferred booking location.</p>

        {/* Display Location List */}
        <div className="address-select-outer">
          {mainstylistLocationData?.results?.map((location, index) => {
            return (
              isAvailableForOnlineBooking(location) &&
              (<div
                key={`location_${index}`}
                className={
                  radioValue === location.id ? "address active" : "address"
                }
              >
                <InputField
                  key={`location_input_${index}`}
                  name={apiConstants.location}
                  type="radio"
                  control={control}
                  customOnChange={(e) => {
                    setValue(apiConstants.location, e.target.value);
                    setLocationId(e.target.value);
                    setValue(apiConstants.timezone, location?.timezone);
                    setLocationWorkingHours(location?.working_hours);
                    if (getValues(apiConstants.location)) {
                      setValue(apiConstants.custom_location, "");
                    }
                  }}
                  id={location.id}
                  // errors={index === 0 ? errors : ""}
                  // inputLabel={item.value}
                />

                <div
                  className="g-map"
                  onClick={() => showInMapClicked(location)}
                >
                  <img src={location.location_image} alt="Google Map" />
                </div>

                <div>
                  { location.online_booking_status && 
                    <p style={{ marginTop: '0px', color: location.online_booking_status === 'Active' ? '#27AE60' : '#F2994A', fontWeight: 'bold', textAlign: 'right'}}>
                      { location.online_booking_status === 'Active' ? location.online_booking_status : 
                        location.online_booking_status.includes('Starts') ? 
                        location.online_booking_status.replace(/Starts\s*/i, 'Taking bookings from ') : 
                        location.online_booking_status.replace(/Ends\s*/i, 'Taking bookings until ') }
                  </p> }
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div>
                      <span className="name">{location.name}</span>
                      <p>{location.address}</p>
                    </div>
                    <div className="radio-btn-img"></div>
                  </div>
                </div>
              </div>)
            );
          })}
        </div>
      </div>
      <div className="bottom-wrapper">
        {/* Mobile Booking */}
        {isMobileBookingAvailable && (
          <div className="mbl-booking">
            <div
              className={
                radioValue === "mbl_booking" ? "address active" : "address"
              }
              onClick={handlePopClick}
            >
              <InputField
                // key={index}
                name={apiConstants.location}
                type="radio"
                control={control}
                  customOnChange={(event) => {
                    const inputValue = event.target.value;
                    setValue(apiConstants.location, inputValue);
                    if (inputValue === MOBILE_BOOKING_FORM_VALUE) {
                      const mobileId = getMobileBookingLocationId(
                        mainstylistLocationData?.results
                      );
                      if (mobileId) {
                        setLocationId(mobileId);
                      }
                    }
                  }}
                id="mbl_booking"
                // errors={errors}
              />

              <div>
                <span className="name">Mobile Booking</span>
                <p>
                  Proceed with mobile booking for any at home or on the go
                  requests.
                </p>
              </div>

              <div className="radio-btn-img"></div>
            </div>
          </div>
        )}
        {getValues(apiConstants.custom_location) && (
          <div className="fetched-booking-data">
            <div className="pop-address">
              <div>
                <span>Address</span>
                <b onClick={handlePopClick}>Edit</b>
              </div>

              <InputField
                name={apiConstants.custom_location}
                type="text"
                control={control}
              />
            </div>
          </div>
        )}

        {/* Service Policy */}
        {isNotEmptyString(mainstylistLocationData?.stylist_info?.service_policy) && (
          <div className="service-policy-section">
            <span className="service-policy-label">Service Policy</span>
            <div 
              className="service-policy-content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  (mainstylistLocationData?.stylist_info?.service_policy || '').replace(/\n/g, '<br />'),
                  {
                    ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'span', 'div', 'hr'],
                    ALLOWED_ATTR: ['href', 'target', 'rel'],
                  }
                )
              }}
            />
          </div>
        )}
        <Button
          className="continue-btn"
          type="submit"
          disabled={!hasValidSelection}
          btnTxt={"Continue"}
          onClick={handleSubmit}
        />

        {access_token ? (
          <Button
            className="rebook-btn"
            btnTxt={"Re-book a past appointment"}
            onClick={re_book_past}
          />
        ) : (
          ""
        )}

        {/* <Link to={{
                    pathname: ROUTES_CONSTANTS.signup,
                    // search: "?sort=name",
                    // hash: "#the-hash",
                    state: { handleSubmit }
                }}>Re-book a past appointment</Link> */}
        {/* <div>{bears}</div> */}

        {showPopup && (
          <div className="mbl-popup-outer">
            <div className="overlay" onClick={handlePopClick}></div>
            <div className="mbl-popup">
              <div className="pop-address">
                <span>Address</span>

                <GooglePlacesSearchBar
                  onChangeLocation={(
                    lat: string,
                    lng: string,
                    address: string,
                    zipCode: number,
                    region: string,
                    country: string,
                    city: string,
                    country_code: string,
                    state: string,
                    state_code: string
                  ) => {
                    setValue(apiConstants.custom_location, address);
                    setValue(apiConstants.lat, lat);
                    setValue(apiConstants.lng, lng);
                    setLocationLatitude(lat);
                    setLocationLongitude(lng);
                    setValue(apiConstants.custom_location_object, {
                      address: address,
                      country: country,
                      country_code: country_code,
                      location: [lat, lng],
                      city: city,
                      zip_code: zipCode,
                      state: state,
                      state_code: state_code,
                    });
                  }}
                  name={apiConstants.custom_location}
                  control={control}
                  value={getValues(apiConstants.address) || ""}
                  // onChanged={(evt: any) => {
                  //     setValue(apiConstants.address, evt.target.value);
                  // }}
                  // errors={errors}
                  label={"My location"}
                  className="search_input"
                  placeholder="Search home address"
                />
              </div>
              <div onClick={handlePopClick} className="close-btn">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.00004 7.4001L1.70004 11.7001C1.31344 12.0867 0.686636 12.0867 0.300037 11.7001C-0.0865626 11.3135 -0.0865635 10.6867 0.300036 10.3001L4.60004 6.0001L0.300037 1.7001C-0.0865626 1.3135 -0.0865627 0.686697 0.300037 0.300098C0.686636 -0.0865017 1.31344 -0.086501 1.70004 0.300098L6.00004 4.6001L10.3 0.300098C10.6866 -0.0865016 11.3134 -0.0865017 11.7 0.300098C12.0866 0.686697 12.0866 1.3135 11.7 1.7001L7.40004 6.0001L11.7 10.3001C12.0866 10.6867 12.0866 11.3135 11.7 11.7001C11.3134 12.0867 10.6866 12.0867 10.3 11.7001L6.00004 7.4001Z"
                    fill="black"
                  />
                </svg>
              </div>

              {locationNotFound && (
                <div className=" locationnotfound">
                  <div className="locationnotfound-popup">
                    <span>{STRING_CONSTANTS.your_location_is_off}</span>
                  </div>
                </div>
              )}
              <Button
                // onClick={reBookButton}
                disabled={!watch(apiConstants.custom_location)}
                className="continue-btn"
                type="submit"
                btnTxt={"Confirm"}
                onClick={MobileBookingBtn}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}